<template>
    <div class="bgBox">
        <div class="contBox">
            <el-header>
                <hq-nav></hq-nav>
            </el-header>
            <el-main>
                <hq-main></hq-main>
            </el-main>
        </div>
        <el-footer class="footer">
            <hq-footer></hq-footer>
        </el-footer>

    </div>
</template>

<script>
    import Nav from "./Nav";
    import Main from "./Main";
    import Footer from "./Footer";

    export default {
        name: "Index",
        data () {
            return {

            }
        },
        components:{
            "hq-nav":Nav,
            "hq-main":Main,
            "hq-footer":Footer
        }
    }
</script>

<style scoped>
    .bgBox{
        width: 100%;
        height: auto;
        background:#000000 url("../assets/images/bg.jpg") no-repeat top center;
        background-size: 100% auto;
    }
    .contBox{
        max-width: 85.5rem;
        height: auto;
        overflow: hidden;
        margin:  0 auto;
    }
    .el-main{
        padding: 0;
    }
    .el-header{
        padding: 0;
        height: auto !important;
    }
    .footer{
        width: 100%;
        height: 7.0625rem !important;
        background: #171717;
        overflow: hidden;
    }


</style>